export const OfferUnsubscribeViewSuccessUat = {
  message: 'offerUnsubscribeSuccess.message',
}
